
import {AdminActionPeriod} from './admin-action-period.model';

export class ActionPeriodList {
    pageCount: number;
    rowCount: number;
    dataList: AdminActionPeriod[] = [];
}
